import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const AmazonIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 40 40"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.3847 29.4938C36.1263 29.206 34.938 29.3052 33.7963 29.4007C32.6633 29.4954 31.5763 29.5864 31.4895 29.2913C31.3152 28.6986 36.7648 27.3258 38.111 28.4012C39.2825 29.3371 36.2578 34.8596 35.4255 34.4138C35.2597 34.325 35.5068 33.6576 35.812 32.8333C36.2685 31.601 36.8547 30.0181 36.3847 29.4938ZM20.0118 33.2903C12.4666 33.2903 7.05951 30.717 4.2674 29.3883C3.09823 28.832 2.38757 28.4938 2.17042 28.6541C1.43467 29.1971 10.0427 35.8984 20.0118 35.8984C28.7303 35.8984 36.2717 31.2622 35.168 30.6463C34.7737 30.4262 33.9473 30.7009 32.6117 31.145C30.2092 31.9437 26.159 33.2903 20.0118 33.2903Z"
          fill="#FF9900"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.3529 28.1881L29.9976 25.7806C30.3458 25.4639 30.3514 24.9274 30.0431 24.5728C28.9523 23.3182 28.6241 22.2729 28.6241 21.5166V11.4608C28.635 9.77789 27.0014 6.41211 20.3816 6.41211C14.4856 6.41211 12.3392 9.85902 11.8562 12.1479C11.765 12.5803 12.1034 12.9617 12.5501 13.0014L16.0342 13.3112C16.4582 13.349 16.839 13.0626 17.0053 12.6768C17.438 11.6744 18.4498 10.4062 20.3816 10.4062C22.3286 10.4062 23.0101 11.8758 23.1075 12.6106V14.8796C13.5669 14.8796 11.1006 18.9692 11.1006 22.8673C11.1006 26.7654 13.9888 28.7147 17.526 28.7147C19.873 28.7147 22.0398 27.4397 23.2416 26.4759C23.5956 26.192 24.1179 26.1861 24.4463 26.4987L26.2079 28.1757C26.5258 28.4781 27.0283 28.4837 27.3529 28.1881ZM21.4702 23.9597C23.6085 22.3571 23.1167 17.8896 23.1167 17.8896C23.1167 17.8896 19.0962 17.6256 17.5262 20.0007C16.6692 21.2973 16.9472 23.056 17.9857 23.9597C18.8497 24.7114 20.305 24.8329 21.4702 23.9597Z"
          fill="#1E1E1E"
        />
      </SvgIcon>
    );
  })
);
